import React, { useState } from "react";
import { getAuth } from "firebase/auth";

const SalvareDate = ({ beneficiar, id, numeComponenta, campuriSalvate }) => {
  const auth = getAuth();
  const userEmail = auth.currentUser?.email || "anonim";

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [motivSchimbare, setMotivSchimbare] = useState("");
  const [loadingSave, setLoadingSave] = useState(false); // nou

  const handleSaveClick = () => setIsModalOpen(true);

  const cancelSave = () => {
    if (loadingSave) return; // nu permite anularea în timpul încărcării
    setIsModalOpen(false);
    setMotivSchimbare("");
    setErrorMessage("");
  };

  const confirmSave = async () => {
        setLoadingSave(true);

    if (!motivSchimbare.trim()) {
      setErrorMessage("Te rog să introduci motivul modificărilor.");
      return;
    }

    setLoadingSave(true);
    setErrorMessage("");

    try {
      const response = await fetch(
        "https://us-central1-epafa-production.cloudfunctions.net/salveazaDate",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            beneficiar,
            id,
            numeComponenta,
            campuriSalvate,
            motivSchimbare,
            userEmail,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Eroare necunoscută la salvare");
      }

      setShowSuccessMessage(true);
      setIsModalOpen(false);
      setMotivSchimbare("");
      setErrorMessage("");
      setTimeout(() => setShowSuccessMessage(false), 3000);
    } catch (error) {
      setErrorMessage("Eroare la salvare: " + error.message);
    } finally {
      setLoadingSave(false);
    }
  };

  return (
    <div>
      <button onClick={handleSaveClick}>Salvează</button>

      {isModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Confirmare</h2>
            <p>Ești sigur că vrei să modifici datele?</p>

            <label>Motivul schimbărilor:</label>
            <textarea
              value={motivSchimbare}
              onChange={(e) => setMotivSchimbare(e.target.value)}
              rows={4}
              style={{ width: "100%", marginBottom: "1rem" }}
              placeholder="Introdu motivul schimbărilor..."
              disabled={loadingSave}
            />

            {errorMessage && (
              <div className="error-message" style={{ color: "red" }}>
                {errorMessage}
              </div>
            )}

<div className="button-group">
  <button onClick={confirmSave} disabled={loadingSave}>
    {loadingSave ? (
      <>
        Se încarcă...
        <span className="spinner"></span>
      </>
    ) : (
      "Da"
    )}
  </button>
  <button onClick={cancelSave} disabled={loadingSave}>
    Nu
  </button>
</div>
</div>
        </div>
      )}

      {showSuccessMessage && (
        <div className="success-message" style={{ color: "green" }}>
          Datele au fost actualizate cu succes!
        </div>
      )}
    </div>
  );
};

export default SalvareDate;
